import downloadFile from "@/helpers/download-file";
export default {
    getList(params = {}) {
        return axios.get("/profiles", { params });
    },
    Profile: {
        async get() {
            const { data } = await axios.get("/profile");

            return data;
        },
        async getPrincipals(id) {
            const data = await axios.get(`/profile/principals/${id}`);

            return data;
        },
        async setPrincipalType(type, step, principalId) {
            const { data } = await axios.post("/profile/principals/type", { type: type, step: step, id: principalId });

            return data;
        },
        async setPrincipalStatus(status, id) {
            const { data } = await axios.post("/profile/principals/status", { status: status, id: id });

            return data;
        },
        async storePrincipalData(form) {
            const { data } = await axios.post("/profile/principals/new", { form: form });

            return data;
        },
        async setPrincipalData(id) {
            const { data } = await axios.get(`/profile/principals/edit/${id}`);

            return data;
        },
        async updatePrincipalData(form, id, userId) {
            const { data } = await axios.put("/profile/principals/update", { form: form, id: id, userId: userId });

            return data;
        },
        async deletePrincipalData(id) {
            const { data } = await axios.post("/profile/principals/delete", { id: id });

            return data;
        },
        async setCurrentPrincipal(id, isEnabled, userId) {
            const { data } = await axios.put("/profile/principals/current", {id: id, isEnabled: isEnabled, userId: userId});

            return data;
        },
        async getPrincipalDocuments(id) {
            const { data } = await axios.get(`/profile/principals/documents/${id}`);
            return data;
        },
        async uploadPrincipalDocument(formData, id) {
            const { data } = await axios.post(`/profile/principals/uploadPrincipalDocument/${id}`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

            return data;
        },
        async downloadPrincipalDocument(id) {
            const url = `/api/profile/principals/documents/download?id=` + id;
            const urlParamsStr = window.open(`${url}`);
        },
        async removePrincipalDocument(id) {
            const { data } = await axios.delete(`/profile/principals/documents/remove/${id}`);

            return data;
        },
        async setType(type) {
            const { data } = await axios.post("/profile/type", { type });

            return data;
        },
        async setData(form) {
            const { data } = await axios.put("/profile", form);

            return data;
        },
        async uploadDocument(formData) {
            const { data } = await axios.post("/profile/documents", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            return data;
        },
        async sendToVerify() {
            const { data } = await axios.post("/profile/verification");

            return data;
        },
        async getDocuments() {
            const { data } = await axios.get("/profile/documents");

            return data;
        },
        async removeDocument(id) {
            const { data } = await axios.delete(`/profile/documents/${id}`);

            return data;
        },
        async getAccounts() {
            const { data } = await axios.get("/profile/accounts");

            return { data };
        },
        async getCertificate() {
            const { data } = await axios.get("/profile/certificate");

            return data;
        },
        async backToFill() {
            const { data } = await axios.put("/profile/backToFill");

            return data;
        },
        async changeReportStatus() {
            const { data } = await axios.put("/profile/changeReportStatus");

            return data;
        },
    },
    Chat: {
        async getMessages(page) {
            const { data } = await axios.get("/messages", { params: { page } });

            return data;
        },
        async sendMessage(message, files) {
            const formData = new FormData();
            formData.append("body", message);
            for (const idx in files) {
                const file = files[idx];
                formData.append(`files[${idx}][attachment]`, file.src);
                if (file.sign) {
                    formData.append(`files[${idx}][sign]`, file.sign);
                }
            }
            const { data } = await axios.post("/messages", formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            return data;
        },
        async fileDownload(messageId, fileId, token) {
            const url = `/api/messages/${messageId}/file/${fileId}`;
            downloadFile(url, token);
        },
    },
};
